import * as actionTypes from '../../actionTypes';
import axios from '../../../../_services/api/axios';

/* ------------------ Machine Create ------------------- */
export const calculatorMachineCreateStart = () => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_CREATE_START
    };
};

export const calculatorMachineCreateSuccess = (machine) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_CREATE_SUCCESS,
        machine: machine
    };
};

export const calculatorMachineCreateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_CREATE_FAIL,
        error: error
    };
};

export const calculatorMachineCreateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_CREATE_RESET
    };
};

export const calculatorMachineCreate = (formData) => {
    return dispatch => {
        dispatch(calculatorMachineCreateStart());
        axios.post( '/production/calculator/machines', formData)
            .then( response => {
                dispatch( calculatorMachineCreateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorMachineCreateFail( error ) );             
            } );
    };
};

/* ----------------- Machine Duplicate ------------------ */
export const calculatorMachineDuplicateCheckSuccess = ( name_duplicate ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_SUCCESS,
        name_duplicate: name_duplicate
    };
};

export const calculatorMachineDuplicateCheckFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_FAIL,
        error: error
    };
};

export const calculatorMachineDuplicateCheckStart = () => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_START
    };
};

export const calculatorMachineDuplicateCheckReset = () => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DUPLICATECHECK_RESET
    };
};

export const calculatorMachineDuplicateCheck = (formData) => {
    return dispatch => {
        dispatch(calculatorMachineDuplicateCheckStart());
        let urlString =  '/production/calculator/machines/duplicate?name='+formData.name;
        if(formData.id) {
            urlString = urlString + "&machineId=" + formData.id;
        }
        axios.get( urlString , { hideGlobalSpinner : true })
            .then( response => {
                dispatch( calculatorMachineDuplicateCheckSuccess( response.data.result ) );
            } )
            .catch( error => {
                dispatch( calculatorMachineDuplicateCheckFail( error ) );              
            } );
    };
};

/* ------------------ Machine Update ------------------- */
export const calculatorMachineUpdateStart = () => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_UPDATE_START
    };
};

export const calculatorMachineUpdateSuccess = (machine) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_UPDATE_SUCCESS,
        machine: machine
    };
};

export const calculatorMachineUpdateFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_UPDATE_FAIL,
        error: error
    };
};

export const calculatorMachineUpdateReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_UPDATE_RESET
    };
};

export const calculatorMachineUpdate = (id, formData) => {
    return dispatch => {
        dispatch(calculatorMachineUpdateStart());
        axios.put( '/production/calculator/machines/'+id, formData)
            .then( response => {
                dispatch( calculatorMachineUpdateSuccess( response.data ) );
            } )
            .catch( error => {
                dispatch( calculatorMachineUpdateFail( error ) );             
            } );
    };
};

/* ------------------ Machine Delete ------------------- */
export const calculatorMachineDeleteStart = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DELETE_START
    };
};

export const calculatorMachineDeleteSuccess = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DELETE_SUCCESS
    };
};

export const calculatorMachineDeleteFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DELETE_FAIL,
        error: error
    };
};

export const calculatorMachineDeleteReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_DELETE_RESET
    };
};

export const calculatorMachineDelete = (id, formData) => {
    return dispatch => {
        dispatch(calculatorMachineDeleteStart());
        axios.delete( '/production/calculator/machines/'+id, formData)
            .then( response => {
                dispatch( calculatorMachineDeleteSuccess( ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "machine", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "machine", key: "default", message: "There was an error, please try it again later.", type: 'error', obj: error} } ); 
                }
                dispatch( calculatorMachineDeleteFail( error ) );             
            } );
    };
};

/* ------------------ Machine Fetch ------------------- */
export const calculatorMachineFetchStart = () => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_FETCH_START
    };
};

export const calculatorMachineFetchSuccess = (machine) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_FETCH_SUCCESS,
        machine: machine
    };
};

export const calculatorMachineFetchFail = ( error ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_FETCH_FAIL,
        error: error
    };
};

export const calculatorMachineFetchReset = ( ) => {
    return {
        type: actionTypes.CALCULATOR_MACHINE_FETCH_RESET
    };
};

export const calculatorMachineFetch = (id) => {
    return dispatch => {
        dispatch(calculatorMachineFetchStart());
        axios.get( '/production/calculator/machines/'+id)
            .then( response => {
                dispatch( calculatorMachineFetchSuccess( response.data ) );
            } )
            .catch( error => {
                if(error.length && error.length === 1) {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "machine", key: error[0].key, message: error[0].message, type: 'error'} } ); 
                }
                else {
                    dispatch( {type: actionTypes.VISUALMESSAGE_SET, payload: {scope: "machine", key: "not_exist", message: "Machine not found", type: 'error', obj: error} } ); 
                } 
                dispatch( calculatorMachineFetchFail( error ) );              
            } );
    };
};



// WEBPACK FOOTER //
// ./src/_store/actions/calculator/machines/machine.js